import { render, staticRenderFns } from "./TradingBetweenCountry.vue?vue&type=template&id=1b14ad9c&"
import script from "./TradingBetweenCountry.vue?vue&type=script&lang=js&"
export * from "./TradingBetweenCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports